// src/components/shared/LoadingState.tsx
import React from 'react';
import { Logomark } from './BrandIcons';

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
}

/** Branded skeleton shell — shows the page's shape while data arrives instead
 *  of a blank screen with a spinner. */
const SkeletonShell: React.FC = () => (
  <div className="skeleton-shell" aria-hidden="true">
    <div className="skeleton-nav">
      <Logomark size={26} className="skeleton-mark" />
      <span className="skeleton-line" style={{ width: 110, height: 14 }} />
    </div>
    <div className="skeleton-hero">
      <div className="skeleton-col">
        <span className="skeleton-line" style={{ width: 140, height: 12 }} />
        <span className="skeleton-line" style={{ width: '92%', height: 42 }} />
        <span className="skeleton-line" style={{ width: '74%', height: 42 }} />
        <span className="skeleton-line" style={{ width: '85%', height: 16 }} />
        <span className="skeleton-line" style={{ width: '60%', height: 16 }} />
        <div className="skeleton-buttons">
          <span className="skeleton-line" style={{ width: 150, height: 46, borderRadius: 12 }} />
          <span className="skeleton-line" style={{ width: 150, height: 46, borderRadius: 12 }} />
        </div>
      </div>
      <div className="skeleton-hero-card" />
    </div>
  </div>
);

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading...',
  fullScreen = false
}) => {
  if (fullScreen) {
    return (
      <div className="loading-screen loading-screen--shell" role="status" aria-label={message}>
        <SkeletonShell />
        <span className="sr-only">{message}</span>
      </div>
    );
  }

  return (
    <div className="loading-inline" role="status">
      <div className="loading-spinner"></div>
      <p>{message}</p>
    </div>
  );
};
